module.exports = __webpack_public_path__ + "static/media/HOME-image4.af1a235b.png";